import { Component } from "@angular/core";

@Component({
  selector: "app-mobile-redirect",
  templateUrl: "./mobile-redirect.component.html",
  styleUrls: ["./mobile-redirect.component.scss"],
})
export class MobileRedirectComponent {}
